import React from 'react';
import NoticeTicker from './components/NoticeTicker';
import NoticeModal from './components/NoticeModal';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import FeatureGrid from './components/FeatureGrid';
import InstructorSection from './components/InstructorSection';
import ServiceAreas from './components/ServiceAreas';
import PricingSection from './components/PricingSection';
import ContactSection from './components/ContactSection';
import MobileActionBar from './components/MobileActionBar';
import './App.css';

function App() {
  return (
    <div className="site-shell">
      <div className="top-bar">
        <NoticeTicker />
        <Navigation />
      </div>
      <main>
        <Hero />
        <FeatureGrid />
        <InstructorSection />
        <ServiceAreas />
        <PricingSection />
        <ContactSection />
      </main>
      <footer className="site-footer">
        <a className="footer-brand" href="#home">RSS Driving School</a>
        <span>Automatic driving lessons in Goulburn and Rockdale, NSW, Australia.</span>
        <span>© {new Date().getFullYear()} RSS Driving School</span>
      </footer>
      <MobileActionBar />
      <NoticeModal />
    </div>
  );
}

export default App;